import React from "react";
import SideImg from "../../atrimages/pervious event images atri/2019/6.jpg";
import { FaEye } from "react-icons/fa";
import Brochure from "../../atrimages/Borealis 2023 Brouchere.pdf";
import { Link } from "react-router-dom";

export default function About() {
  return (
    <>
      {/* <!-- About Section --> */}
      <div className="aboutcontainer" id="about">
        <div className="column">
          <img
            src={SideImg}
            alt="evntimg"
            data-aos="fade-up"
            data-aos-duration="1000"
          />
        </div>
        <div className="column rightText">
          <div data-aos="fade-up" data-aos-duration="1000">
            <h1>BOREALIS</h1>
            <h3>Rise to Shine</h3>
            <p>
              <b>BOREALIS</b> is the ATRI’s technical and Cultural festival that
              is organized on a grand scale. This provides an occasion for the
              students to display their knowledge and innovations in the field
              of technology. On this occasion various technical events like
              paper presentation, quiz, elocution, LAN gaming etc are organized.
              Technical experts are invited, who apart from judging the best
              talent in all the activities, enrich the students with their
              valuable inputs for the budding engineers to excel in their
              academic and professional lives and serve the nation.
            </p>
          </div>

          <a href={Brochure} target="_blank" download="Borealis 2023 Brouchere">
            <button className="eventreg-btn scudule">
              Borealis Brochure <FaEye style={{ fontSize: "20px" }} />
            </button>
          </a>
          <Link
            to="register"
            className="animate__animated animate__shakeY animate__infinite"
          >
          <button className="eventreg-btn scudule">Register &gt;&gt;</button>
           
          </Link>
        </div>
      </div>
    </>
  );
}
